/*
* shortcutsFor vanilla JS events
* */

export function click(target, callback, bubble = true){
    if (target){
        try {
            target.addEventListener('click', callback, bubble)
        } catch (e) {
            console.log(e);
        }
    }

}





// WEBPACK FOOTER //
// ./js/core/nEvents.js